import { tv, type VariantProps } from 'tailwind-variants';
export type OrStatsListVariants = VariantProps<typeof orStatsListVariants>;

const orStatsListVariants = tv({
  slots: {
    base: 'w-fit grid-flow-cols grid-cols-1 grid-rows-1 grid gap-12 justify-center font-Figtree md:flex-row md:gap-0 md:w-full md:grid-flow-col',
    statContainer:
      'flex flex-col justify-center border-b-2 last:border-b-0 pb-4 px-0 lg:px-14 md:pb-2 md:border-b-0 md:border-r-2 md:last:border-r-0',
    title: 'text-center',
    subtitle: 'text-center',
  },
  variants: {
    type: {
      basic: {
        statContainer: 'flex-col border-skin-stroke-tertiary gap-[1.125rem]',
        title: '!font-Figtree',
      },
      'home-plan': {
        statContainer: 'border-skin-stroke-secondary gap-6',
        title: '!font-Thermal',
      },
    },
    transform: {
      uppercase: { subtitle: 'uppercase' },
      normal: { subtitle: '' },
    },
    itemsLength: {
      '2': { base: 'md:grid-cols-2' },
      '3': { base: 'md:grid-cols-3' },
      '4': { base: 'md:grid-cols-4' },
      '5': { base: 'md:grid-cols-5' },
    },
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default orStatsListVariants;
